import styled from 'styled-components'
import Type from '../../Components/Type'
import L from '../../Components/L'

const SimulationImg = styled(L).attrs({
  width: { xx: '125px', sm: '155px' },
  height: { xx: '75px', sm: '95px' },
})`
  overflow: hidden;
  border-radius: ${props => props.theme.globals.borderRadius}px;
`

const SimulationDescription = styled(Type)`
  max-width: 330px;
  height: 60px;
  position: relative;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${props =>
    props.theme.mixins.mq(
      `
      height: 40px;
      -webkit-line-clamp: 2;
    `,
      'sm',
    )} // &:before {
    //   content: '';
    //   height: 20px;
    //   width: 100px;
    //   position: absolute;
    //   bottom: 0;
    //   right: 0;
    //   background: linear-gradient(to right, rgba(247, 247, 247, 0), rgba(247, 247, 247, 1));
    // }
`

const StatusDot = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: ${props => props.theme.palette.bg[props.status].main};
`

const StyledSimulation = styled(L).attrs({
  position: 'relative',
  width: '100%',
  display: 'grid',
  ai: { xx: 'flex-start', sm: 'center' },
  jc: 'space-between',
  gap: { xx: 1.5, sm: 4 },
  columns: { xs: 'auto 1fr auto' },
  pX: 2,
  pY: 2,
})`
  &,
  & svg,
  & .simulation__title {
    transition: ${props => props.theme.mixins.transition(['background-color', 'color'])};
  }

  &:hover {
    background-color: ${props => props.theme.palette.bg.paperHover.main};

    .simulation__title {
      color: ${props => props.theme.palette.tertiary.light};
    }

    svg {
      color: ${props => props.theme.palette.primary.main};
    }
  }
`

const StyledSimIcon = styled.div`
    display: grid;
    justify-items: center;
    position: relative;
    transition: ${props => props.theme.mixins.transition(['transform'])};
    &:after {
      content: '${props => props.label}';
      ${props => props.theme.typography.h4}
      color: ${props => props.theme.palette.primary.main};
      position: absolute;
      top: 100%;
      opacity: 0;
      visibility: hidden;
      transition: ${props => props.theme.mixins.transition(['opacity', 'visibility'])};
    }
    &:hover {
      transform: translateY(-10px);
      &:after {
        opacity: 1;
        visibility: visible;
      }
    }
  `

export { SimulationImg, SimulationDescription, StatusDot, StyledSimulation, StyledSimIcon }
